import { useEffect, useState } from 'react';

export type BreakpointName = keyof typeof breakpoints;

const breakpoints = {
  sm: { width: '(min-width: 360px) and (max-width: 767px)' },
  md: { width: '(min-width: 768px) and (max-width: 1279px)' },
  lg: { width: '(min-width: 1280px) and (max-width: 1439px)' },
  xl: { width: '(min-width: 1440px) and (max-width: 1919px)' },
  '2xl': { width: '(min-width: 1920px)' },
};

function useBreakpoint(): BreakpointName | null {
  const [activeBreakpoint, setActiveBreakpoint] =
    useState<BreakpointName | null>(null);

  useEffect(() => {
    function getActiveBreakpoint() {
      if (!window.matchMedia) return;

      // eslint-disable-next-line no-restricted-syntax
      for (const breakpoint in breakpoints) {
        const typedBreakpoint = breakpoint as BreakpointName;
        const breakpointWidth = breakpoints[typedBreakpoint].width;

        if (window.matchMedia(breakpointWidth).matches) {
          setActiveBreakpoint(typedBreakpoint);
          break;
        }
      }
    }

    // Execute once for initial render
    getActiveBreakpoint();

    window.addEventListener('resize', getActiveBreakpoint);

    return () => {
      window.removeEventListener('resize', getActiveBreakpoint);
    };
  }, []);

  return activeBreakpoint;
}

export { useBreakpoint };
